export default __webpack_public_path__ + "static/media/数据科学导论.f69ac4f0.jpg";